// ←-Zurück + Kontext-Titel für die Top-Mitte der Mobile-Shell —
// Detailseiten (documents/$id, invoices/$id, invoices/new) und Master-
// Detail-Weichen (Chat-Thread, Mail-Liste/-Nachricht) portalen dies via
// MobileTopCenter. Bleibt PHONE-ONLY (Gate in MobileTopCenter): das
// Tablet-Band hat keine Top-Leiste — dort tragen die Desktop-Köpfe die
// eigenen phone:hidden-Zurück-Links (in T3 verifiziert für alle Nutzer
// dieses Bausteins).
//
// Gestaltungs-Entscheid (User-Vorgabe „entscheide nach Optik"): Das 🔥
// links bleibt unangetastet, der ← lebt IN der Mitte-Zone direkt links vom
// Titel. Die Gruppe ←+Titel bleibt dabei zentriert (justify-center des
// Outlets) — kurze Titel sitzen optisch wie auf allen anderen Seiten in
// der Mitte; lange Titel truncaten, füllen die Zone und schieben den ←
// automatisch an den linken Zonen-Rand. Beide Varianten aus dem Auftrag
// konvergieren damit, ohne Extra-Layout-Fallunterscheidung.

import { ChevronLeft } from 'lucide-react'

export function MobileBackTitle({
  title,
  onBack,
  backAriaLabel = 'Zurück',
}: {
  title: string
  onBack: () => void
  backAriaLabel?: string
}) {
  return (
    <>
      <button
        type="button"
        onClick={onBack}
        aria-label={backAriaLabel}
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-text-secondary hover:bg-bg-overlay hover:text-text-primary"
      >
        <ChevronLeft className="h-5 w-5" />
      </button>
      {/* min-w-0: truncate greift im Flex-Row nur mit aufgehobenem
          min-width:auto (Muster der Shell-Top-Mitte). */}
      <span className="min-w-0 truncate text-xs font-medium text-text-primary">{title}</span>
    </>
  )
}
